// test596
(596 && 0);
